import { render, staticRenderFns } from "./playlists.vue?vue&type=template&id=45073d58&scoped=true&"
import script from "./playlists.vue?vue&type=script&lang=js&"
export * from "./playlists.vue?vue&type=script&lang=js&"
import style0 from "./playlists.vue?vue&type=style&index=0&id=45073d58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45073d58",
  null
  
)

export default component.exports